import { v4 as uuidv4 } from "uuid";
import { create } from "zustand";
import type { ModalItem, ModalPropsMap } from "../types/modal.types";
import type { ModalKey } from "../lib/constants/modal.constants";

export type ModalState = {
  modals: ModalItem[];
  topModal: ModalItem | null;
  openModal: <K extends ModalKey>(
    key: K, 
    props: ModalPropsMap[K] // (추론된 타입)
  ) => string;

  closeModal: (id: string) => void;
  closeModalsByKey: (key: ModalKey) => void;
  clearModal: () => void;
};

export const useModalStore = create<ModalState>((set, get) => ({
  modals: [],
  topModal: null,

  openModal: <K extends ModalKey>(key: K, props: ModalPropsMap[K]) => {
    const id = uuidv4();
    // (props가 ModalPropsMap[K] 타입이고, 
    //  ModalItem.props도 ModalPropsMap[K] 타입이므로 일치함)
    const modal = { id, key, props } as ModalItem; 

    set((state) => ({
      modals: [...state.modals, modal],
      topModal: modal,
    }));
    return id;
  },

  closeModal: (id) => {
    const newModals = get().modals.filter((m: ModalItem) => m.id !== id);
    set({
      modals: newModals,
      topModal: newModals[newModals.length - 1] || null,
    });
  },

  closeModalsByKey: (key) => {
    const newModals = get().modals.filter((m: ModalItem) => m.key !== key);
    set({
      modals: newModals,
      topModal: newModals[newModals.length - 1] || null,
    });
  },

  clearModal: () => 
    set(() => ({ 
      modals: [], 
      topModal: null
    })),
}));